export default function DatePicker() {
  return {
    lineHeight: 3.3
  }
}
